import * as React from 'react';
import { capitaliseFirstLetter } from '../../utils';
import { Box } from '../Box';
import * as flexboxStyles from '../common/flexbox.module.css';
import * as styles from './Grid.module.css';

export const Grid = React.forwardRef(function Grid(
  {
    children,
    className = '',
    element = 'div',
    gap = 'none',
    height = 'auto',
    padding = 'none',
    width = 'auto',
    ...rest
  },
  ref,
) {
  const gapClass = `gap${capitaliseFirstLetter(gap)}`;

  const combinedClasses = [styles.grid, flexboxStyles[gapClass], className]
    .filter(Boolean)
    .join(' ');

  return (
    <Box
      className={combinedClasses}
      display="flex"
      element={element}
      height={height}
      padding={padding}
      ref={ref}
      width={width}
      {...rest}
    >
      {children}
    </Box>
  );
});
